import React from "react";
import { css, jsx } from "@emotion/react";
import getBadge from "./Badges";

const SeriesCard = ({ post, id }) => {
    const getBadgeBlog = (post) => {
                return (
                    <div>
                    <style jsx>
                        {`
                            .badge {
                                width: 8rem;
                                height: 8rem;
                                display: block;
                                border-radius: 100%;
                                background: url(${getBadge(post)}) no-repeat;
                                background-size: cover;
                                position: absolute;
                                top: -4rem;
                                right: 10rem;
                            }
                        `}
                    </style>
                    <div className="badge" />
                </div>)
    };

    const getUrl = (post)=>{
        if(post.parent_slug === 'tag')
            return `/blog/${post.parent_slug}/${post.slug}/`;
        else
            return `/blog/${post.parent_slug}?series=${post.slug}`;
    }
    
    return (
        <>
            <style jsx>
                {`
                    .indus {
                        color: #fc566f;
                    }

                    .rose {
                        display: block;
                        color: #fc566f;
                        margin: 1rem 0;
                        font-weight: 400;
                        text-align: center;
                    }
                    .wrapper {
                        background: #ffffff;
                        box-shadow: 7px 7px 0px 0px rgb(0 0 0 / 11%);
                        border-radius: 1rem;
                        width: 29rem;
                        position: relative;
                        max-height: 41rem;
                    }
                    .f-img {
                        background-size: cover;
                        display: block;
                        width: 100%;
                        border-top-right-radius: 1rem;
                        border-top-left-radius: 1rem;
                        height: 28rem;
                    }
                    .header {
                        justify-content: center;
                        display: flex;
                        flex-wrap: wrap;
                        width: 100%;
                        padding: 2rem;
                        height: 13rem;
                    }

                    .title {
                        font-family: Soleil;
                        font-size: 1.8rem;
                        line-height: normal;
                        color: #393972;
                    }
                    .desc {
                        font-size: 1.4rem;
                        color: #616161;
                        line-height: normal;
                        font-weight: 300;
                        text-align: center;
                    }
                    .author {
                        margin-top: 1.9rem;
                        margin-right: 1rem;
                        position: relative;
                    }
                    .a-img {
                        width: 6.1rem;
                        height: 6.1rem;
                        display: block;
                        border-radius: 100%;
                        border: 0.1rem solid #eee;
                        background-size: cover;
                    }
                    .a-name {
                        font-size: 1.5rem;
                        font-weight: bold;
                        color: #393972;
                        letter-spacing: 0;
                        margin-top: 2.3rem;
                        display: block;
                    }
                    .col {
                        flex: 1;
                    }
                `}
            </style>
            <div className="wrap-card">
                <div className="item" key={"c" + id}>
                    <div className="wrapper">
                        {getBadgeBlog(post)}
                        <div>
                            <div
                                className="f-img"
                                style={{
                                    background: `url(${post.headImg}) no-repeat center center / cover`,
                                }}
                            />
                        </div>
                        <div className="header">
                            <h2 className="title">{post.name}</h2>
                            <p className="desc">
                                {post.desc}
                                <br />
                                <a href={getUrl(post)} className="rose">
                                    Read More
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SeriesCard;
